(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elektroheimat-cookie-settings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-eh-cookie-settings]');
  if (!trigger) return;
  event.preventDefault();
  const errorText = trigger.nextElementSibling;
  errorText.hidden = true;
  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    errorText.hidden = false;
  }
});
  } catch(e) { console.error(e); }
})();

})();
